import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import PricingCards from "@/sections/PricingCards";
import FAQAccordion from "@/sections/FAQAccordion";
import CTABanner from "@/components/CTABanner";

export default function PricingPage() {
  return (
    <>
      <SEO
        title="Pricing — Transparent Plans"
        description="Simple, transparent pricing for premium websites and digital marketing. Choose Starter, Growth or Enterprise. No hidden fees, ever."
        path="/pricing"
      />
      <PageHeader
        eyebrow="Pricing"
        title="Transparent pricing that scales"
        highlight="with you"
        subtitle="Clear scopes, honest pricing and plans for every growth stage. Not sure which fits? Book a free consultation."
      />
      <PricingCards showHeader={false} />
      <FAQAccordion />
      <div className="py-10"><CTABanner /></div>
    </>
  );
}
